(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dd-case-studies-center-v2"]) return;
  try {
    
function initCaseviewFeedback(){document.querySelectorAll('[data-caseview-dialog]').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const status=dialog.closest('form').querySelector('[data-caseview-success]');dialog.querySelector('[data-caseview-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>status.focus());if(typeof dialog.showModal==='function')dialog.showModal();else status.focus();});}
initCaseviewFeedback();document.addEventListener('shopify:section:load',initCaseviewFeedback);

document.querySelectorAll('.dd-caseindex').forEach(root=>{root.querySelectorAll('[data-case-filter]').forEach(button=>button.addEventListener('click',()=>{const selected=button.dataset.caseFilter;root.querySelectorAll('[data-case-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));let count=0;root.querySelectorAll('[data-case-group]').forEach(card=>{card.hidden=selected!=='all'&&card.dataset.caseGroup!==selected;if(!card.hidden)count++;});root.querySelector('[data-case-count]').textContent=count+' customer project'+(count===1?'':'s');}));});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-case-unified"]) return;
  try {
    
function initCaseviewFeedback(){document.querySelectorAll('[data-caseview-dialog]').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const status=dialog.closest('form').querySelector('[data-caseview-success]');dialog.querySelector('[data-caseview-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>status.focus());if(typeof dialog.showModal==='function')dialog.showModal();else status.focus();});}
initCaseviewFeedback();document.addEventListener('shopify:section:load',initCaseviewFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-cnc-collection"] && !Shopify.designMode) return;
  try {
    
function initCncFeedback(){document.querySelectorAll('[data-cnc-dialog]').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const status=dialog.closest('form').querySelector('[data-cnc-success]');dialog.querySelector('[data-cnc-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>status.focus());if(typeof dialog.showModal==='function')dialog.showModal();else status.focus();});}
initCncFeedback();document.addEventListener('shopify:section:load',initCncFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-cnc-product"]) return;
  try {
    
function initFabricFeedback(){document.querySelectorAll('[data-fabric-dialog]').forEach(d=>{if(d.dataset.ready)return;d.dataset.ready='true';const s=d.closest('form').querySelector('[data-fabric-success]');d.querySelector('[data-fabric-close]').addEventListener('click',()=>d.close());d.addEventListener('close',()=>s.focus());if(typeof d.showModal==='function')d.showModal();else s.focus();});}initFabricFeedback();document.addEventListener('shopify:section:load',initFabricFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-co2-collection"] && !Shopify.designMode) return;
  try {
    
function initCo2Feedback(){document.querySelectorAll('[data-co2-dialog]').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const status=dialog.closest('form').querySelector('[data-co2-success]');dialog.querySelector('[data-co2-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>status.focus());if(typeof dialog.showModal==='function')dialog.showModal();else status.focus();});}
initCo2Feedback();document.addEventListener('shopify:section:load',initCo2Feedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-co2-product"]) return;
  try {
    
function initFabricFeedback(){document.querySelectorAll('[data-fabric-dialog]').forEach(d=>{if(d.dataset.ready)return;d.dataset.ready='true';const s=d.closest('form').querySelector('[data-fabric-success]');d.querySelector('[data-fabric-close]').addEventListener('click',()=>d.close());d.addEventListener('close',()=>s.focus());if(typeof d.showModal==='function')d.showModal();else s.focus();});}initFabricFeedback();document.addEventListener('shopify:section:load',initFabricFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-contact-page"]) return;
  try {
    
function initCaseviewFeedback(){document.querySelectorAll('[data-help-dialog]').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const status=dialog.closest('form').querySelector('[data-help-success]');dialog.querySelector('[data-help-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>status.focus());if(typeof dialog.showModal==='function')dialog.showModal();else status.focus();});}
initCaseviewFeedback();document.addEventListener('shopify:section:load',initCaseviewFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-dual-co2-product"]) return;
  try {
    
function initFabricFeedback(){document.querySelectorAll('[data-fabric-dialog]').forEach(d=>{if(d.dataset.ready)return;d.dataset.ready='true';const s=d.closest('form').querySelector('[data-fabric-success]');d.querySelector('[data-fabric-close]').addEventListener('click',()=>d.close());d.addEventListener('close',()=>s.focus());if(typeof d.showModal==='function')d.showModal();else s.focus();});}initFabricFeedback();document.addEventListener('shopify:section:load',initFabricFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-eco-solvent-product"] && !Shopify.designMode) return;
  try {
    
function initEcoFeedback(){document.querySelectorAll('[data-eco-dialog]').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';dialog.querySelector('[data-eco-close]').addEventListener('click',()=>dialog.close());if(typeof dialog.showModal==='function')dialog.showModal();});}initEcoFeedback();document.addEventListener('shopify:section:load',initEcoFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-fabric-product"] && !Shopify.designMode) return;
  try {
    
function initFabricFeedback(){document.querySelectorAll('[data-fabric-dialog]').forEach(d=>{if(d.dataset.ready)return;d.dataset.ready='true';const s=d.closest('form').querySelector('[data-fabric-success]');d.querySelector('[data-fabric-close]').addEventListener('click',()=>d.close());d.addEventListener('close',()=>s.focus());if(typeof d.showModal==='function')d.showModal();else s.focus();});}initFabricFeedback();document.addEventListener('shopify:section:load',initFabricFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-factory-page"]) return;
  try {
    
function initCaseviewFeedback(){document.querySelectorAll('[data-factory-dialog]').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const status=dialog.closest('form').querySelector('[data-factory-success]');dialog.querySelector('[data-factory-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>status.focus());if(typeof dialog.showModal==='function')dialog.showModal();else status.focus();});}
initCaseviewFeedback();document.addEventListener('shopify:section:load',initCaseviewFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-fiber-cutting-collection"] && !Shopify.designMode) return;
  try {
    
function initFibselectFeedback(){document.querySelectorAll('[data-fibselect-dialog]').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const status=dialog.closest('form').querySelector('[data-fibselect-success]');dialog.querySelector('[data-fibselect-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>status.focus());if(typeof dialog.showModal==='function')dialog.showModal();else status.focus();});}
initFibselectFeedback();document.addEventListener('shopify:section:load',initFibselectFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-home-b2b"] && !Shopify.designMode) return;
  try {
    
function showInquiryConfirmation() {
 document.querySelectorAll('[data-inquiry-confirmation]').forEach(dialog => {
  if (dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const message = dialog.previousElementSibling;
  message.scrollIntoView({block:'center',behavior:'instant'});
  dialog.querySelector('[data-inquiry-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>message.focus({preventScroll:true}));
  if (typeof dialog.showModal === 'function') dialog.showModal();
  else message.focus();
 });
}
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',showInquiryConfirmation);
else showInquiryConfirmation();
document.addEventListener('shopify:section:load',showInquiryConfirmation);

document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-category-inquiry]');
  if (!link) return;
  const section = link.closest('.dd-home-b2b');
  const select = section?.querySelector('select[name="contact[Product Interested]"]');
  if (select) { select.value = link.dataset.categoryInquiry; select.dispatchEvent(new Event('change', { bubbles: true })); }
});

function initCuttingPreviews(root = document) {
  root.querySelectorAll('[data-cutting-preview]').forEach(media => {
    if (media.dataset.previewReady) return;
    media.dataset.previewReady = 'true';
    const video = media.querySelector('video');
    const button = media.querySelector('button');
    const label = button.querySelector('[data-video-label]');
    const status = media.querySelector('[role="status"]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let wanted = false;
    const stop = () => {
      wanted = false; video.pause(); media.classList.remove('is-playing');
      button.setAttribute('aria-pressed', 'false'); label.textContent = button.dataset.playLabel;
    };
    const fail = () => { stop(); status.textContent = status.dataset.failure; };
    const play = async () => {
      wanted = true; status.textContent = '';
      if (!video.getAttribute('src')) video.src = video.dataset.src;
      video.muted = true;
      try {
        await video.play();
        if (!wanted || !media.isConnected || document.hidden) { video.pause(); return; }
        media.classList.add('is-playing');button.setAttribute('aria-pressed', 'true');label.textContent = button.dataset.stopLabel;
      } catch (error) { if (wanted) fail(); }
    };
    media.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && !reduced.matches) play(); });
    media.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') stop(); });
    button.addEventListener('click', () => { if (wanted) stop(); else play(); });
    media.addEventListener('keydown', event => { if (event.key === 'Escape') stop(); });
    media.addEventListener('focusout', event => { if (!media.contains(event.relatedTarget)) stop(); });
    video.addEventListener('error', fail);
    const visibility = () => { if (document.hidden) stop(); };
    document.addEventListener('visibilitychange', visibility);
    const observer = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) stop(); }, { threshold: 0 });
    observer.observe(media);
    const unload = event => { if (event.target.contains(media)) { stop(); observer.disconnect(); document.removeEventListener('visibilitychange', visibility); document.removeEventListener('shopify:section:unload', unload); } };
    document.addEventListener('shopify:section:unload', unload);
  });
}
initCuttingPreviews();
document.addEventListener('shopify:section:load', event => initCuttingPreviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-industry-crafts"] && !Shopify.designMode) return;
  try {
    
function initCraftFeedback(){document.querySelectorAll('[data-craft-dialog]').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const status=dialog.closest('form').querySelector('[data-craft-success]');dialog.querySelector('[data-craft-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>status.focus());if(typeof dialog.showModal==='function')dialog.showModal();else status.focus();});}
initCraftFeedback();document.addEventListener('shopify:section:load',initCraftFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-industry-display"] && !Shopify.designMode) return;
  try {
    
function initDisplayFeedback(){document.querySelectorAll('[data-display-dialog]').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const status=dialog.closest('form').querySelector('[data-display-success]');dialog.querySelector('[data-display-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>status.focus());if(typeof dialog.showModal==='function')dialog.showModal();else status.focus();});}
initDisplayFeedback();document.addEventListener('shopify:section:load',initDisplayFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-industry-furniture"] && !Shopify.designMode) return;
  try {
    
function initWoodFeedback(){document.querySelectorAll('[data-wood-dialog]').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const status=dialog.closest('form').querySelector('[data-wood-success]');dialog.querySelector('[data-wood-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>status.focus());if(typeof dialog.showModal==='function')dialog.showModal();else status.focus();});}
initWoodFeedback();document.addEventListener('shopify:section:load',initWoodFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-industry-signage"] && !Shopify.designMode) return;
  try {
    
function initSignageFeedback(){document.querySelectorAll('[data-signage-dialog]').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const status=dialog.closest('form').querySelector('[data-signage-success]');dialog.querySelector('[data-signage-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>status.focus());if(typeof dialog.showModal==='function')dialog.showModal();else status.focus();});}
initSignageFeedback();document.addEventListener('shopify:section:load',initSignageFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-industry-textile"] && !Shopify.designMode) return;
  try {
    
function initTextileFeedback(){document.querySelectorAll('[data-textile-dialog]').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const status=dialog.closest('form').querySelector('[data-textile-success]');dialog.querySelector('[data-textile-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>status.focus());if(typeof dialog.showModal==='function')dialog.showModal();else status.focus();});}
initTextileFeedback();document.addEventListener('shopify:section:load',initTextileFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-marking-collection"] && !Shopify.designMode) return;
  try {
    
function initMarkselectFeedback(){document.querySelectorAll('[data-markselect-dialog]').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const status=dialog.closest('form').querySelector('[data-markselect-success]');dialog.querySelector('[data-markselect-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>status.focus());if(typeof dialog.showModal==='function')dialog.showModal();else status.focus();});}
initMarkselectFeedback();document.addEventListener('shopify:section:load',initMarkselectFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-panorama-1610"]) return;
  try {
    
function initFabricFeedback(){document.querySelectorAll('[data-fabric-dialog]').forEach(d=>{if(d.dataset.ready)return;d.dataset.ready='true';const s=d.closest('form').querySelector('[data-fabric-success]');d.querySelector('[data-fabric-close]').addEventListener('click',()=>d.close());d.addEventListener('close',()=>s.focus());if(typeof d.showModal==='function')d.showModal();else s.focus();});}initFabricFeedback();document.addEventListener('shopify:section:load',initFabricFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-printer-collection"] && !Shopify.designMode) return;
  try {
    
function initPrintselectFeedback(){document.querySelectorAll('[data-printselect-dialog]').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const status=dialog.closest('form').querySelector('[data-printselect-success]');dialog.querySelector('[data-printselect-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>status.focus());if(typeof dialog.showModal==='function')dialog.showModal();else status.focus();});}
initPrintselectFeedback();document.addEventListener('shopify:section:load',initPrintselectFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-support-page"]) return;
  try {
    
function initCaseviewFeedback(){document.querySelectorAll('[data-help-dialog]').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const status=dialog.closest('form').querySelector('[data-help-success]');dialog.querySelector('[data-help-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>status.focus());if(typeof dialog.showModal==='function')dialog.showModal();else status.focus();});}
initCaseviewFeedback();document.addEventListener('shopify:section:load',initCaseviewFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-systems-overview-v1"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-systems-overview]').forEach((section) => {
    section.dataset.enhanced = 'true';
    const tabs = Array.from(section.querySelectorAll('[data-system-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-system-panel]'));
    const activate = (tab) => {
      tabs.forEach((item) => {
        const selected = item === tab;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.systemPanel === tab.dataset.systemTab));
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const offset = event.key === 'ArrowRight' ? 1 : -1;
        const nextTab = tabs[(index + offset + tabs.length) % tabs.length];
        activate(nextTab);
        nextTab.focus();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-welding-collection"] && !Shopify.designMode) return;
  try {
    
function initWeldselectFeedback(){document.querySelectorAll('[data-weldselect-dialog]').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const status=dialog.closest('form').querySelector('[data-weldselect-success]');dialog.querySelector('[data-weldselect-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>status.focus());if(typeof dialog.showModal==='function')dialog.showModal();else status.focus();});}
initWeldselectFeedback();document.addEventListener('shopify:section:load',initWeldselectFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
